import {removePartnerPaymentCard} from "../Util/queries";
import {GetPartnerCardDetails} from "./partnerCardInfoDetailsAction";

export const RemovePartnerCard = () => async dispatch => {
    try {
        let request = await removePartnerPaymentCard();
        if (request.status === 200 || request.status === 201 || request.status === 204) {
            dispatch(GetPartnerCardDetails());
        } else throw Error(request.statusText);
    } catch (e) {
        console.error(e);
    }
}